import React from 'react';
import {Colors} from '../../../configs/colors';
import {ImageProps} from './Image.props';
import './Image.styles.css';

export const Image: React.FC<ImageProps> = ({
  url,
  width = '200px',
  height = 'auto',
  backgroundColor = Colors.Transparent,
  borderRadius = '0px',
  border = 0,
  margin = '0px',
  top,
  left,
  onClick,
  className = '',
}) => {
  return (
    <img
      className={`image-style ${className}`}
      src={url} style={{
        width,
        height,
        backgroundColor,
        borderRadius,
        border,
        margin
      }}
      onClick={onClick}
    />
  );
};
